const UsersIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 10.5C9.1875 10.5 6.9375 8.2875 6.9375 5.5875C6.9375 2.8875 9.1875 0.675003 12 0.675003C14.8125 0.675003 17.0625 2.8875 17.0625 5.5875C17.0625 8.2875 14.8125 10.5 12 10.5ZM12 2.3625C10.125 2.3625 8.625 3.825 8.625 5.5875C8.625 7.35 10.125 8.8125 12 8.8125C13.875 8.8125 15.375 7.35 15.375 5.5875C15.375 3.825 13.875 2.3625 12 2.3625Z'
        fill='#111928'
      />
      <path
        d='M19.3875 23.3625H4.61251C3.86251 23.3625 3.26251 22.7625 3.26251 22.0125V18.6375C3.26251 14.9625 6.26251 11.9625 9.93751 11.9625H14.1C17.775 11.9625 20.775 14.9625 20.775 18.6375V22.0125C20.7375 22.725 20.1375 23.3625 19.3875 23.3625ZM4.95001 21.675H19.0875V18.6375C19.0875 15.9 16.8375 13.65 14.1 13.65H9.90001C7.16251 13.65 4.91251 15.9 4.91251 18.6375V21.675H4.95001Z'
        fill='#111928'
      />
    </svg>
  );
};

export default UsersIcon;
